import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// import Datepicker from "../sub_components/Datepicker_.js";
import ReactDatetime from "react-datetime";
// import DateTimePicker from 'react-datetime-picker';

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import Search from '@material-ui/icons/Search'
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import ViewColumn from '@material-ui/icons/ViewColumn'
import SaveAlt from '@material-ui/icons/SaveAlt'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Add from '@material-ui/icons/Add'
import Check from '@material-ui/icons/Check'
import FilterList from '@material-ui/icons/FilterList'
import Remove from '@material-ui/icons/Remove'
import Clear from '@material-ui/icons/Clear'
import ArrowDownward from "@material-ui/icons/ArrowDownward"
import ArrowUpward from "@material-ui/icons/ArrowUpward"

import {
  addRecord,
  updateRecord,
  deleteRecord,
  readAllRecords
} from "../../services_/bookingConfirmRestService";

import Paper from '@material-ui/core/Paper';
import { ViewState } from '@devexpress/dx-react-scheduler';
import {
  Scheduler,
  DayView,
  WeekView,
  MonthView,
  Toolbar,
  Appointments,
  ViewSwitcher,
  TodayButton,
  DateNavigator,
} from '@devexpress/dx-react-scheduler-material-ui';

import axios from 'axios';
import { appointments } from "./appointments";

import Navbar from "components_/sub_components/Navbar.js";

export default function VenueBooking(props) {
  // class VenueBooking extends React.Component {
  // state = {};
  // componentDidMount() {
  //   document.documentElement.scrollTop = 0;
  //   document.scrollingElement.scrollTop = 0;
  //   this.refs.main.scrollTop = 0;
  // }
  const [scheduleState, setScheduleState] = useState({
    data: [],
    currentViewName: 'work-week',
  });
  const [state, setState] = useState({
    columns: [
      {
        title: "ID",
        field: "id",
        editable: "onAdd"
      },
      {
        title: "Start Time",
        field: "startDate",
        type: "datetime"
      },
      {
        title: "End Time",
        field: "endDate",
        type: "datetime"
      },
      {
        title: "Status",
        field: "members"
      },
      {
        title: "Title",
        field: "title"
      },
      {
        title: "User Name",
        field: "userName"
      },
      {
        title: "User Mobile",
        field: "userMobile"
      },
      {
        title: "User Email",
        field: "userEmail"
      },
      {
        title: "User Organization",
        field: "userOrganization"
      },
      {
        title: "User Title",
        field: "userTitle"
      },
    ],
    data: []
  });

  useEffect(() => {
    async function fetchData() {
      const records = await readAllRecords();
      console.log("..[log, VenueBookin.jsx]..")
      console.log(records);
      setState({ columns: state.columns, data: records });
    }
    fetchData();
  }, []);

  const [error, setError] = useState(false);

  const currentViewNameChange = (currentViewName) => {
    setScheduleState({ currentViewName });
  };


  return (
    <>
      <Navbar languageState={props.languageState} updateLanguageState={props.updateLanguageState} />
      {/* <DemoNavbar /> */}
      {/* <main ref="main"> */}
      <div className="position-relative">
        {/* shape Hero */}
        <section className="section section-lg section-shaped pb-250">
          <div className="shape shape-style-1 shape-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-lg-md d-flex">
            <div className="col px-0">
              <Row>
                <Col lg="6">
                  <h1 className="display-3 text-white">
                    Venue Booking (Administrator) {" "}
                    {/* <span>completed with examples</span> */}
                  </h1>
                  <p className="lead text-white">
                    administrator page -- Booking Confirmation
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-white"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </section>
        {/* 1st Hero Variation */}
      </div>
      <section className="section section-lg pt-lg-0 mt--200">

        <Container>
          <Paper>
            <Scheduler
              data={state.data}
              height={600}
            >
              <ViewState
                // defaultCurrentDate="2020-06-28"
                currentViewName={"work-week"}
                onCurrentViewNameChange={currentViewNameChange}
              />
              <WeekView
                name="work-week"
                displayName="Work Week"
                cellDuration={60}
                excludedDays={[0, 7]}
                startDayHour={8}
                endDayHour={18}
              />
              {/* <MonthView />
              <ViewSwitcher />
              <DayView /> */}
              <Toolbar />
              <TodayButton />
              <Appointments />
              <DateNavigator />
            </Scheduler>
          </Paper>
        </Container>
      </section>

      <section className="section bg-secondary">
        <Container>
          <Paper>
            <Grid item style={{ marginTop: 0 }}>
              <MaterialTable
                icons={{
                  Edit: Edit,
                  Delete: Delete,
                  Add: Add,
                  Clear: Clear,
                  ArrowDownward: ArrowDownward,
                  SortArrow: ArrowUpward,
                  Check: Check,
                  DetailPanel: ChevronRight,
                  Export: SaveAlt,
                  Filter: FilterList,
                  FirstPage: FirstPage,
                  LastPage: LastPage,
                  NextPage: ChevronRight,
                  PreviousPage: ChevronLeft,
                  Search: Search,
                  ThirdStateCheck: Remove,
                }}
                title="Venue Booking System"
                columns={state.columns}
                data={state.data}
                editable={{
                  // below is async function - because there are keywords: Promise and resolve
                  onRowAdd: newData => new Promise(resolve => {
                    setTimeout(() => {
                      // below "resolve()" -> empty inside bracket means do nth to resolve Promise for above "resolve()"
                      resolve();
                      setState(prevState => {
                        const data = [...prevState.data];
                        data.push(newData);
                        return { ...prevState, data };
                      });
                      addRecord(newData);
                    }, 600);
                  }),
                  onRowUpdate: (newData, oldData) => new Promise(resolve => {
                    setTimeout(() => {
                      resolve();
                      if (oldData) {
                        setState(prevState => {
                          const data = [...prevState.data];
                          data[data.indexOf(oldData)] = newData;
                          return { ...prevState, data };
                        });
                        updateRecord(newData);
                      }
                    }, 600);
                  }),
                  onRowDelete: oldData => new Promise(resolve => {
                    setTimeout(() => {
                      resolve();
                      setState(prevState => {
                        const data = [...prevState.data];
                        data.splice(data.indexOf(oldData), 1);
                        return { ...prevState, data };
                      });
                      deleteRecord(oldData);
                    }, 600);
                  })
                }}
              />
            </Grid>
          </Paper>
        </Container>
      </section>

    </>
  );

}
